import * as ActionTypes from './RestaurantsInfoActionsTypes';
import {
  IUpdateInfo,
} from '../../types/IRestaurantInfoStore';
import { IAppActions } from '../../types/IAppActions';
import locales from "../../locales";

/** @description Экшен на редактирование полей у выбранного ресторана */
export function updateRestaurantInfo(restaurantInfo: IUpdateInfo): IAppActions {
  return {
    type: ActionTypes.UPDATE_RESTAURANT_INFO_REQUEST,
    payload: restaurantInfo,
  };
}

/** @description Экшен на обработку успешного редактирования ресторана */
export function updateRestaurantInfoSuccess(): IAppActions {
  return {
    type: ActionTypes.UPDATE_RESTAURANT_INFO_SUCCESS,
    message: 'Поле отредактировано',
  };
}

/** @description Экшен на обработку ошибки редактирования ресторана */
export function updateRestaurantInfoError(): IAppActions {
  return {
    type: ActionTypes.UPDATE_RESTAURANT_INFO_ERROR,
    error: 'Не удалось отредактировать поле',
  };
}

export function scrapeRestaurantInfo(id: number): IAppActions {
  return {
    type: ActionTypes.SCRAPE_RESTAURANT_INFO_REQUEST,
    payload: {
      id: id
    },
  };
}

export function scrapeRestaurantInfoSuccess(message: string = 'Данные загружены'): IAppActions {
  return {
    type: ActionTypes.SCRAPE_RESTAURANT_INFO_SUCCESS,
    message: message,
  };
}

export function scrapeRestaurantInfoError(): IAppActions {
  return {
    type: ActionTypes.SCRAPE_RESTAURANT_INFO_ERROR,
    error: locales.t('restaurantCard.scrapeInfo.error')
  };
}

